import Cookies from 'js-cookie';
import { encrypt, decrypt } from '../utils/secure_storage';

function isElectron() {
    // Use the exposed IS_ELECTRON flag from preload.cjs
    if (typeof window !== 'undefined' && window.IS_ELECTRON === true) {
        return true;
    }
    
    return false;
}

// Get token using appropriate storage method
export const getAccessToken = () => {
  if (isElectron()) {
    // Get encrypted token from localStorage and decrypt it
    const encryptedToken = localStorage.getItem('access_token');
    return decrypt(encryptedToken);
  }
  
  // Get encrypted token from cookies and decrypt it
  const encryptedCookieToken = Cookies.get('access_token');
  return decrypt(encryptedCookieToken);
};

export const getUserId = () => {
  if (isElectron()) {
    const encryptedId = localStorage.getItem('userID');
    return decrypt(encryptedId);
  }
  
  const encryptedCookieId = Cookies.get('userID');
  return decrypt(encryptedCookieId);
};

export const getOrganizationId = () => {
  if (isElectron()) {
    const encryptedOrgId = localStorage.getItem('organizationID');
    return decrypt(encryptedOrgId);
  }
  
  const encryptedCookieOrgId = Cookies.get('organizationID');
  return decrypt(encryptedCookieOrgId);
};

export const setAuthData = (accessToken, userId) => {
  if (isElectron()) {
    // Encrypt token and userId before storing
    localStorage.setItem('access_token', encrypt(accessToken));
    localStorage.setItem('userID', encrypt(userId));
  } else {
    // Encrypt before storing in cookies
    Cookies.set('access_token', encrypt(accessToken), {
      expires: 7,
      secure: true,
      sameSite: 'strict'
    });
    
    Cookies.set('userID', encrypt(userId), {
      expires: 7,
      secure: true,
      sameSite: 'strict'
    });
  }
};

export const setOrganizationId = (organizationId) => {
  if (isElectron()) {
    localStorage.setItem('organizationID', encrypt(organizationId));
  } else {
    Cookies.set('organizationID', encrypt(organizationId), {
      expires: 7,
      secure: true,
      sameSite: 'strict'
    });
  }
};

export const getRefreshToken = () => {
  return localStorage.getItem('refresh_token') || null;
};

/** Refresh token is always stored in localStorage (web and Electron). */
export const setRefreshToken = (refreshToken) => {
  if (!refreshToken) return;
  localStorage.setItem('refresh_token', refreshToken);
};

/** Remove the refresh token used by the silent-refresh interceptor. */
export const clearRefreshToken = () => {
  localStorage.removeItem('refresh_token');
};

export const setAccessToken = (accessToken) => {
  if (isElectron()) {
    localStorage.setItem('access_token', encrypt(accessToken));
  } else {
    Cookies.set('access_token', encrypt(accessToken), {
      expires: 7,
      secure: true,
      sameSite: 'strict',
    });
  }
};

export const clearAccessToken = () => {
  if (isElectron()) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('userID');
    localStorage.removeItem('organizationID');
  } else {
    const cookieOptions = {
      path: '/',
      domain: '',
      secure: true,
      sameSite: 'strict'
    };
    
    // Clear standard auth cookies
    Cookies.remove('access_token', cookieOptions);
    Cookies.remove('userID', cookieOptions);
    Cookies.remove('organizationID', cookieOptions);
    
    Cookies.remove('persist:auth', cookieOptions);
    Cookies.remove('persist%3Aauth', cookieOptions);
    Cookies.remove('persist:kycSetup', cookieOptions);
    Cookies.remove('persist%3AkycSetup', cookieOptions);
    Cookies.remove('persist:user', cookieOptions);
    Cookies.remove('persist%3Auser', cookieOptions);
    Cookies.remove('persist:organization', cookieOptions);
    Cookies.remove('persist%3Aorganization', cookieOptions);
    
    // Clear refresh token cookie if present
    Cookies.remove('refresh_token', cookieOptions);
    
    if (typeof document !== 'undefined') {
      document.cookie = 'persist:auth=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      document.cookie = 'persist%3Aauth=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
  }
};